export function areArraysEqual(
  array1: any[] | null | undefined,
  array2: any[] | null | undefined,
  ignoreOrder: boolean = true,
) {
  if (!array1 || !array2) return false;
  if (array1.length !== array2.length) return false;

  if (ignoreOrder) {
    array1 = [...array1].sort();
    array2 = [...array2].sort();
  }

  for (let i = 0; i < array1.length; i++) {
    if (array1[i] !== array2[i]) return false;
  }

  return true;
}
